export const CommunityNewsRoomTranslations = {
    communityNewsRoomTranslations: {
        pageTitle: 'Sala de prensa de la comunidad',
        description: 'Bienvenido a nuestra sala de redacción. Aquí encontrará noticias y eventos de la empresa, así como información sobre nuestros cuidadores blogueros y expertos contribuyentes.'
    }
}